import React, { Component } from 'react'

import { ProSidebar,  MenuItem } from 'react-pro-sidebar';
import 'react-pro-sidebar/dist/css/styles.css';

import { Menu, Icon } from 'antd';
import { AppstoreOutlined, MailOutlined, SettingOutlined, SearchOutlined, LogoutOutlined } from '@ant-design/icons';
import { BrowserRouter as Router, Link  } from "react-router-dom";
import { MDBBreadcrumb, MDBBreadcrumbItem,MDBIcon } from "mdbreact";

const { SubMenu } = Menu;

export default class Leftmenu extends Component {

      handleClick = e => {
        console.log('click ', e);
      };

      logout() {
        // localStorage.removeItem(('token'))
         localStorage.removeItem(('loginstatus'))
         localStorage.removeItem(('type2'))
         localStorage.removeItem(('name'))
         localStorage.clear();
      
        // setTimeout(() => {
      
           window.location.href = '/grade'
        // }, 1000);
        // message.success("ออกจากระบบแล้ว")
      }


      sendkey({ key }) {
        localStorage.setItem('key', key)
       // console.log(key)
      }

      SubMenukey({ key }) {
        localStorage.setItem('keysub', key)
        console.log(key)
      }

    render() {

       
        
        return (
           <div>
            <p></p>
   <Menu
        onClick={this.handleClick}
        style={{ width: 270 }}
        defaultSelectedKeys={[localStorage.getItem('key')]}
        defaultOpenKeys={[localStorage.getItem('keysub')]}
        mode="inline"
      >
        {/* <SubMenu key="sub1" icon={<MailOutlined />} title={<Link style={{textDecoration:"none"}} to="/components/home/home"> <span> หน้าแรก  </span> </Link>}>
          <Menu.ItemGroup key="g1" title="Item 1">
            <Menu.Item key="1">Option 1</Menu.Item>
            <Menu.Item key="2">Option 2</Menu.Item>
          </Menu.ItemGroup>
          <Menu.ItemGroup key="g2" title="Item 2">
            <Menu.Item key="3">Option 3</Menu.Item>
            <Menu.Item key="4">Option 4</Menu.Item>
          </Menu.ItemGroup>
        </SubMenu>
        <SubMenu key="sub2" icon={<AppstoreOutlined />} title="Navigation Two">
          <Menu.Item key="5">Option 5</Menu.Item>
          <Menu.Item key="6">Option 6</Menu.Item>
          <SubMenu key="sub3" title="Submenu">
            <Menu.Item key="7">Option 7</Menu.Item>
            <Menu.Item key="8">Option 8</Menu.Item>
          </SubMenu>
        </SubMenu>
        <SubMenu key="sub4" icon={<SettingOutlined />} title="Navigation Three">
          <Menu.Item key="9">Option 9</Menu.Item>
          <Menu.Item key="10">Option 10</Menu.Item>
          <Menu.Item key="11">Option 11</Menu.Item>
          <Menu.Item key="12">Option 12</Menu.Item>
        </SubMenu> */}
        {localStorage.getItem('type2') === "000355" || localStorage.getItem('type2') === "001546" || localStorage.getItem('type2') === "001506" ?<>
        
        </>:<>
        <SubMenu onTitleClick={this.SubMenukey}  key="subhome" icon={<SettingOutlined />}
                      title={
                        <Link style={{textDecoration:"none"}} to="/adminfaculty">
                        <span>
                          ผลการเรียน
                        </span>
                        </Link>
                      }
                  >
                      <Menu.Item onClick={this.sendkey} key="12"><Link style={{textDecoration:"none"}} to="/adminfaculty"><span><MDBIcon icon="caret-right" /> ผลการเรียนทั้งหมด</span></Link></Menu.Item>
                      <Menu.Item onClick={this.sendkey} key="13"><Link style={{textDecoration:"none"}} to="/adminfacultyst1"><span><MDBIcon icon="caret-right" /> ผลการเรียนภาคปกติ</span></Link></Menu.Item>
                      <Menu.Item onClick={this.sendkey} key="14"><Link style={{textDecoration:"none"}} to="/adminfacultyst5"><span><MDBIcon icon="caret-right" /> ผลการเรียนภาคปกติ(แม่สอด)</span></Link></Menu.Item>
                      <Menu.Item onClick={this.sendkey} key="15"><Link style={{textDecoration:"none"}} to="/adminfacultyst2"><span><MDBIcon icon="caret-right" /> ผลการเรียนภาคกศ.บป.(กำแพงเพชร)</span></Link></Menu.Item>
                      <Menu.Item onClick={this.sendkey} key="16"><Link style={{textDecoration:"none"}} to="/adminfacultyst3"><span><MDBIcon icon="caret-right" /> ผลการเรียนภาคกศ.บป.(แม่สอด)</span></Link></Menu.Item>
                      <Menu.Item onClick={this.sendkey} key="17"><Link style={{textDecoration:"none"}} to="/adminfacultyst4"><span><MDBIcon icon="caret-right" /> ผลการเรียน ป.โท</span></Link></Menu.Item>
                      <Menu.Item onClick={this.sendkey} key="18"><Link style={{textDecoration:"none"}} to="/adminfacultyst7"><span><MDBIcon icon="caret-right" /> ผลการเรียน ป.เอก</span></Link></Menu.Item>
                      <Menu.Item onClick={this.sendkey} key="19"><Link style={{textDecoration:"none"}} to="/adminfacultyst6"><span><MDBIcon icon="caret-right" /> ผลการเรียน ป.วิชาชีพครู</span></Link></Menu.Item>
                      <Menu.Item onClick={this.sendkey} key="20"><Link style={{textDecoration:"none"}} to="/adminfacultyst8"><span><MDBIcon icon="caret-right" /> ผลการเรียน ผู้ช่วยพยาบาล</span></Link></Menu.Item>

        </SubMenu>

        <SubMenu onTitleClick={this.SubMenukey}  key="subhome2" icon={<SearchOutlined />}
                      title={
                        <Link style={{textDecoration:"none"}} to="/adminfacultyi">
                        <span>
                         ผลการเรียนจาก i
                        </span>
                        </Link>
                      }
                  >
        </SubMenu>
        </>}

        

        {/* <SubMenu  key="subhome" icon={<SearchOutlined />}
                      title={
                        <Link style={{textDecoration:"none"}} to="/adminfacultyst1">
                        <span>
                         ผลการเรียนภาคปกติ
                        </span>
                        </Link>
                      }
                  >
        </SubMenu>

        <SubMenu  key="subhome" icon={<SearchOutlined />}
                      title={
                        <Link style={{textDecoration:"none"}} to="/adminfacultyst5">
                        <span>
                         ผลการเรียนภาคปกติ(แม่สอด)
                        </span>
                        </Link>
                      }
                  >
        </SubMenu>

        <SubMenu  key="subhome" icon={<SearchOutlined />}
                      title={
                        <Link style={{textDecoration:"none"}} to="/adminfacultyst2">
                        <span>
                         ผลการเรียนภาคกศ.บป.(กำแพงเพชร)
                        </span>
                        </Link>
                      }
                  >
        </SubMenu>

        <SubMenu  key="subhome" icon={<SearchOutlined />}
                      title={
                        <Link style={{textDecoration:"none"}} to="/adminfacultyst3">
                        <span>
                         ผลการเรียนภาคกศ.บป.(แม่สอด)
                        </span>
                        </Link>
                      }
                  >
        </SubMenu>

        <SubMenu  key="subhome" icon={<SearchOutlined />}
                      title={
                        <Link style={{textDecoration:"none"}} to="/adminfacultyst4">
                        <span>
                         ผลการเรียน ป.โท
                        </span>
                        </Link>
                      }
                  >
        </SubMenu>

        <SubMenu  key="subhome" icon={<SearchOutlined />}
                      title={
                        <Link style={{textDecoration:"none"}} to="/adminfacultyst7">
                        <span>
                         ผลการเรียน ป.เอก
                        </span>
                        </Link>
                      }
        >

        </SubMenu>

        <SubMenu  key="subhome" icon={<SearchOutlined />}
                      title={
                        <Link style={{textDecoration:"none"}} to="/adminfacultyst6">
                        <span>
                         ผลการเรียน ป.วิชาชีพครู
                        </span>
                        </Link>
                      }
                  >
        </SubMenu> */}

        <SubMenu onTitleClick={this.logout}  
                 key="subhome" icon={<LogoutOutlined /> }
                     title={
                        <Link style={{textDecoration:"none"}} to="/">
                        <span>
                          ออกจากระบบ
                        </span>
                        </Link>
                      }
                  >
        </SubMenu>

                  
      </Menu>
      </div>
           
        )
    }
}
